import { useNavigate } from 'react-router'
import { useEffect } from 'react'
import { DiagnosisDetailsDto } from '@/infra/api/generated/model'

const useQuestionLayoutNavigation = ({ id, questions }: DiagnosisDetailsDto) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (globalThis.location.pathname.endsWith(`/diagnoses/${id}/questions`)) {
      const firstUnanswered = questions.find((q) => q.answer === null)?.order ?? 1
      void navigate(`/diagnoses/${id}/questions/${firstUnanswered}`, {
        replace: true,
        viewTransition: true,
      })
    }
  }, [id, navigate, questions])

  const goToQuestion = (index: number) => {
    void navigate(`/diagnoses/${id}/questions/${questions[index].order}`, { viewTransition: true })
  }
  return { goToQuestion }
}

export default useQuestionLayoutNavigation
